var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewRelic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_15499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5668 32.6128V47.3781L39.7819 54.7623V63.9909L60.5638 51.994V27.997L52.5668 32.6128Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7819 25.2317L52.5668 32.6128L60.5638 27.997L39.7819 16L19 27.997L26.994 32.6128L39.7819 25.2317Z",
    fill: "#1CE783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7879 44.6128V59.3781L39.7819 63.9909V39.997L19 27.997V37.2287L31.7879 44.6128Z",
    fill: "#1D252C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_15499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6604,
    height: 48,
    fill: "white",
    transform: "translate(19 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRelic);
export default __webpack_public_path__ + "static/media/new-relic.6cf8d469775e695177f72a6b43adffed.svg";
export { ForwardRef as ReactComponent };